import React, { useMemo, useState } from "react";
import {
  View,
  Text,
  TextInput,
  Platform,
} from "react-native";
import Colors from "../constants/Colors";
import { Ionicons } from "@expo/vector-icons";




const usToggleOnFocus = (initialState = false) => {
  const [show, toggle] = useState(initialState);
  
  const eventHandlers = useMemo(() => ({
    onFocus: () => toggle(true),
    onBlur: () => toggle(false),
  }), []);

  return [show, eventHandlers];
}


const INPUWEB = (props) => {


  const [show, eventHandlers] = usToggleOnFocus();



  return (




  
    
    



<div >

     <div style={{ width: "50%", height: 20,position:'absolute',top:70,left:"30%",borderRadius:5,justifyContent:"center",alignItems:"center", backgroundColor: "white", ...props.stylelabel }}>
         <text style={{ fontFamily: "MontserratLight", fontSize: 13,position:"absolute" ,left:"20%", color: (show == true ? Colors.primary : Colors.secondText3) }}>{props.label}</text>
         </div>
    
    <input   {...eventHandlers}
  
  
    style={{width:"70%",height:50,  marginTop: 80,marginLeft:10, borderStyle: 'solid',
    borderRadius:5,
    borderWidth: 1,
    fontFamily: "MontserratLight",
    outlineColor:(show == true ? Colors.primary : Colors.secondText3),...props.style}}
     
    
    type={props.type}
        id={props.id}
        name={props.name}
        onChange={props.onChange}
        value={props.value}
        
      />
    </div>


  );
}

export default INPUWEB